import { useContext } from "react";

import { QueryClientMiddlewareContext } from "@/components/QueryClientProvider";

export const useQueryClientMiddleware = () => {
    const context = useContext(QueryClientMiddlewareContext);
    if (!context) {
        throw new Error("useQueryClientMiddleware must be used within QueryClientProvider");
    }

    return context;
};
